import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice';

//Common store for all global states.
export const store = configureStore({
  reducer: {
    userAuth: authReducer
  }
});

